<template>
    <div class="flex" style="height: calc(100vh - 56px - 1rem)">
        <LMap ref="map" :zoom="11" @update:zoom="updateZoom" :center="center" :minZoom="10" style="height: 100%"
            @ready="onMapReady" :maxBounds="maxBounds" :max-bounds-viscosity="1" @update:bounds="updateMapBound"
            :use-global-leaflet="true" :options="{ zoomControl: false }" @click="addMarker">
            <LControl position="topright">
                <Message severity="warn" closable icon="pi pi-eye" pt:content:class="py-1" class="md:block hidden">Zoom
                    vào để hiện các điểm
                    trường!</Message>
            </LControl>
            <LControl position="topleft">
                <InputGroup>
                    <InputGroupAddon class="bg-teal-500 border-none">
                        <i class="pi pi-map" style="color: var(--primary-contrast-color)" id="iconMap"></i>
                    </InputGroupAddon>
                    <IconField>
                        <AutoComplete v-model="searchValue" :suggestions="dsTruongHocSearch"
                            placeholder="Tìm kiếm tên trường" class="md:min-w-[20rem] min-w-[70vw]"
                            inputClass="rounded-none" panelClass="md:max-w-[20rem] max-w-[70vw]"
                            @complete="searchTruongHoc" optionLabel="ten_truong" optionValue="truong_id" autoOptionFocus
                            completeOnFocus forceSelection @option-select="selectTruongHocSearch" size="small"
                            :virtualScrollerOptions="{ itemSize: 14, showLoader: true, delay: 250 }"
                            pt:option:class="!h-fit">
                            <template #option="slotProps">
                                <ItemOptionWithIcon :item="slotProps.option"></ItemOptionWithIcon>
                            </template>
                        </AutoComplete>
                        <InputIcon class="pi pi-times z-[10]" @click="clickClearSearchValue" v-if="searchValue" />
                    </IconField>

                    <InputGroupAddon class="bg-primary border-none p-0">
                        <Button icon="fa fa-directions" size="small" v-tooltip="'Tìm đường'"
                            @click="toggleSearch"></Button>
                    </InputGroupAddon>
                </InputGroup>

                <!-- <Button  @click="toggleSearch" :icon="'pi pi-search'" rounded
                        v-tooltip.top="'Tìm kiếm'"></Button> -->
            </LControl>

            <Drawer v-model:visible="drawerFindLocation" :modal="false" :dismissable="false"
                class="!h-fit md:ml-4 ml-0 md:min-w-[35rem] min-w-full" style="top:calc(-20% - 6rem)"
                @hide="hideDrawer">
                <template #header>
                    <div
                        class="w-full h-[2.5rem] rounded-bl-[5rem] rounded-br-[5rem] bg-primary text-primary-revert text-center flex items-center justify-center">
                        <span style="color: var(--primary-contrast-color)">Chỉ đường</span>
                    </div>
                </template>
                <div class="flex flex-row gap-4 p-4 border rounded-md  bg-white relative">
                    <div class="flex flex-col gap-2 justify-center">
                        <i class="fa fa-map-pin text-red-500 self-center"></i>
                        <i class="fa fa-ellipsis-vertical self-center"></i>
                        <i class="pi pi-map-marker text-blue-500 self-center"></i>
                    </div>
                    <div class="flex flex-col gap-2">
                        <IconField>
                            <AutoComplete ref="refAutoFrom" v-model="searchValueFrom"
                                :suggestions="dsTruongHocSearchFrom"
                                placeholder="Chọn điểm trường bắt đầu hoặc nhập vào bản đồ"
                                inputClass="md:min-w-[25rem] min-w-[70vw]" panelClass="md:max-w-[25rem] max-w-[70vw]"
                                @complete="searchTruongHocFrom" optionLabel="ten_truong" optionValue="truong_id"
                                autoOptionFocus forceSelection completeOnFocus @option-select="selectTruongHocSearch"
                                size="small" :tabindex="1" searchLocale="vi"
                                :virtualScrollerOptions="{ itemSize: 14, showLoader: true, delay: 250 }"
                                @focus="setFocusedAutocomplete(1)" pt:option:class="!h-fit">
                                <template #option="slotProps">
                                    <ItemOptionWithIcon :item="slotProps.option"></ItemOptionWithIcon>
                                </template>
                            </AutoComplete>
                            <InputIcon class="pi pi-times" @click="clickClearSearchValueFrom" />

                        </IconField>

                        <IconField>
                            <AutoComplete ref="refAutoTo" v-model="searchValueTo" :suggestions="dsTruongHocSearchTo"
                                placeholder="Chọn điểm trường bắt đầu hoặc nhập vào bản đồ"
                                inputClass="md:min-w-[25rem] min-w-[70vw]" panelClass="max-w-[25rem] max-w-[70vw]"
                                @complete="searchTruongHocTo" optionLabel="ten_truong" optionValue="truong_id"
                                autoOptionFocus forceSelection completeOnFocus @option-select="selectTruongHocSearch"
                                size="small" :tabindex="2"
                                :virtualScrollerOptions="{ itemSize: 14, showLoader: true, delay: 250 }"
                                @focus="setFocusedAutocomplete(2)" pt:option:class="!h-fit">
                                <template #option="slotProps">
                                    <ItemOptionWithIcon :item="slotProps.option"></ItemOptionWithIcon>
                                </template>
                            </AutoComplete>
                            <InputIcon class="pi pi-times" @click="clickClearSearchValueTo" />

                        </IconField>
                    </div>
                    <div class="flex justify-center">
                        <Button icon="pi pi-sort-alt" text @click="swapMarkerToFrom"></Button>
                    </div>
                </div>
                <div class="flex justify-end mt-2">
                    <Button icon="pi pi-search" label="Tìm đường" text size="small" @click="clickTimDuong"></Button>
                </div>
            </Drawer>
            <LControlZoom position="bottomright" />
            <LControl position="bottomleft" class="leaflet-control !mb-0">
                <div class="relative bg-cyan-100 bg-opacity-50 p-1">
                    <span class="text-primary font-bold">Phát triển bởi VNPT Trà Vinh</span>
                </div>
            </LControl>
            <LControl position="bottomleft">
                <SpeedDial :model="itemsStyle" direction="right" :showIcon="'pi pi-map'"
                    :buttonProps="{ severity: 'primary', rounded: true }" :hideOnClickOutside="false">
                    <template #item="slotProps">
                        <Button @click="changeLayer(slotProps.item)"
                            :severity="selectedStyle?.name == slotProps.item.name ? 'warn' : 'primary'">
                            <i :class="slotProps.item.icon"></i>
                            <span class="item-label">{{ slotProps.item.label }}</span>
                        </Button>
                    </template>
                </SpeedDial>
            </LControl>


            <LControl position="bottomleft">
                <Button ref="btnMenu" @click="toggleMenu" :severity="isShowMenu ? 'danger' : 'primary'"
                    :icon="isShowMenu ? 'pi pi-times' : 'pi pi-bars'" rounded v-tooltip.top="'Bộ lọc'"></Button>
                <Popover ref="op" :dismissable="false" @hide="onHideOp">
                    <Card :pt="{ body: 'pt-0 px-0' }" class="w-[20rem]">
                        <template #title>
                            <div
                                class="w-full h-[2.5rem] rounded-bl-[5rem] rounded-br-[5rem] bg-primary text-primary-revert text-center flex items-center justify-center">
                                <span style="color: var(--primary-contrast-color)">Bộ lọc</span>
                            </div>
                        </template>
                        <template #content>
                            <ScrollPanel
                                :class="['px-5 transition-all duration-300 overflow-hidden bg-surface-0 dark:bg-surface-900 text-surface-700 dark:text-white/80 border-none']"
                                style="height: 100%">
                                <Divider align="center" type="solid">
                                </Divider>
                                <div class="my-4">
                                    <label for="phong_id">Phòng</label>
                                    <MultiSelect :maxSelectedLabels="2"
                                        :selectedItemsLabel="`${selectedPhongGd.length == phongGds.length ? 'Tất cả' : 'Chọn {0} PGD'}`"
                                        @select-all-change="phongGDSelectAllHook" id="phong_id" class="w-full"
                                        :options="phongGds" v-model="selectedPhongGd" optionLabel="tenphong"
                                        optionValue="phong_id" filter />
                                </div>
                                <div class="my-4">
                                    <label for="cap_id">Cấp học</label>
                                    <MultiCheckbox :options="capHocs" v-model="selectedCaphoc" optionLabel="tencap"
                                        optionValue="cap_id"></MultiCheckbox>
                                    <!-- <Listbox :maxSelectedLabels="2" id="phong_id" class="w-full" listStyle="min-height:150px"
                            :options="capHocs" v-model="selectedCaphoc" optionLabel="tencap"
                            optionValue="cap_id" multiple>
                            <template #option="slotProps">
                                <div class="flex items-center">
                                    <Checkbox :value="slotProps.selected" class="mr-2" binary/>
                                    <span>{{ slotProps.option.tencap }}</span>
                                </div>
                            </template>
            </Listbox> -->

                                </div>

                                <div class="my-4">
                                    <label for="cap_id">Loại hình</label>
                                    <MultiCheckbox :options="loaiHinhs" v-model="selectedLoaihinh"
                                        optionLabel="loaihinh" optionValue="loaihinh_id">
                                    </MultiCheckbox>
                                    <!-- <MultiSelect :maxSelectedLabels="2"
                            :selectedItemsLabel="`${selectedLoaihinh.length == selectedLoaihinh.length ? 'Tất cả' : 'Chọn {0} loại hình'}`"
                            @select-all-change="loaihinhSelectAllHook" id="loaihinh_id" class="w-full"
                            :options="loaiHinhs" v-model="selectedLoaihinh" optionLabel="loaihinh"
                            optionValue="loaihinh_id" filter /> -->
                                </div>
                            </ScrollPanel>
                        </template>
                    </Card>
                </Popover>
            </LControl>




            <LTileLayer :url="url" :attribution="attribution" />
            <LTileLayer v-if="selectedStyle.name == 'satellite'"
                url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png" :max-zoom="20"
                :min-zoom="0"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                :options="{
                    ext: 'png'
                }" />
            <LGeoJson v-for="(item, i) in geojsons" :geojson="item.geojson" :options-style="getStyle(item.options)"
                :options="item.options" :key="i">
            </LGeoJson>



            <LMarker v-for="(item, i) in dsTruongHocFilter" :lat-lng="item.toado" :name="item.ma_moet" ref="markerRefs"
                :key="item.truong_id" @click="clickMarkerTruongHoc(item.truong_id)">
                <LIcon class-name="bg-none border-none">
                    <CircleMarker
                        :bg-color="`${item.loaihinh_id == 1 ? 'bg-green-700 w-6 h-6' : item.loaihinh_id == 2 ? 'bg-teal-500 w-6 h-6' : 'bg-cyan-500 w-6 h-6'}`"
                        :class-icon="`${item.truonghoc_caphoc.length > 1 ? 'fa fa-city' : item.truonghoc_caphoc[0].dm_cap.icon} text-base`"
                        :key="item.truong_id">
                    </CircleMarker>
                    <!-- <div class="font-bold text-[8px]">{{ item.options.title }}</div> -->
                </LIcon>
                <LTooltip :options="{
                    permanent: false,
                    direction: 'auto',
                    opacity: 0.9,
                    interactive: true,
                    offset: [25, 5],
                    className: '!border-none !p-0 !m-1 !shadow-none'
                }" class="text-orange-500 drop-shadow-md">
                    {{ item.ten_truong }}
                </LTooltip>
                <!-- <LPopup @popupclose="selectedMarkerTruongHoc.value = null" :options="{
                    autoClose: false,
                    autoPan: true,
                    closeButton: false,
                    minWidth: '90rem'
                }">
                    
                </LPopup> -->
            </LMarker>

            <Dialog v-model:visible="isShowDialogMarker" :style="{ width: '80vw' }" @hide="onHideDialogMarker"
                :draggable="false" modal>
                <template #header>
                    <div v-if="selectedMarkerTruongHoc || selectedMarkerPhongGiaoDuc || selectedMarkerSoGiaoDuc"
                        class="w-full h-[2.5rem] rounded-bl-[5rem] rounded-br-[5rem] bg-primary text-primary-revert text-center flex items-center justify-center">
                        <span class="uppercase" style="color: var(--primary-contrast-color)">{{
                            selectedMarkerTruongHoc?.ten_truong || selectedMarkerPhongGiaoDuc?.tenphong ||
                            selectedMarkerSoGiaoDuc?.tenso || ''
                        }}</span>
                    </div>
                </template>
                <DetailSchool v-if="selectedMarkerTruongHoc" :item="selectedMarkerTruongHoc"></DetailSchool>
                <DetailDistrict v-else-if="selectedMarkerPhongGiaoDuc" :item="selectedMarkerPhongGiaoDuc">
                </DetailDistrict>
                <DetailDepartment v-else-if="selectedMarkerSoGiaoDuc" :item="selectedMarkerSoGiaoDuc">
                </DetailDepartment>

                <div v-else
                    class="rounded border border-surface-200 dark:border-surface-700 p-6 bg-surface-0 dark:bg-surface-900">
                    <div class="flex mb-4">
                        <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
                        <div>
                            <Skeleton width="10rem" class="mb-2"></Skeleton>
                            <Skeleton width="5rem" class="mb-2"></Skeleton>
                            <Skeleton height=".5rem"></Skeleton>
                        </div>
                    </div>
                    <Skeleton width="100%" height="150px"></Skeleton>
                    <div class="flex justify-between mt-4">
                        <Skeleton width="4rem" height="2rem"></Skeleton>
                        <Skeleton width="4rem" height="2rem"></Skeleton>
                    </div>
                </div>
            </Dialog>



            <LMarker v-for="(item, i) in geojsons" :lat-lng="item.options.toado" :name="`marker` + i"
                :zIndexOffset="1000 + i" @click="clickMarkerPhongGiaoDuc(item.options.id)">
                <LIcon class-name="bg-none border-none">
                    <CircleMarker bg-color="bg-blue-500 w-10 h-10" class-icon="fas fa-building text-2xl">
                    </CircleMarker>
                </LIcon>
                <LTooltip :options="{
                    permanent: false,
                    direction: 'auto',
                    opacity: 0.9,
                    interactive: true,
                    offset: [25, 5],
                    className: '!border-none !p-0 !m-1 !shadow-none'
                }" class="text-teal-500 drop-shadow-md">
                    {{ item.options.title }}
                </LTooltip>
            </LMarker>

            <LMarker v-if="sgd" :lat-lng="sgd.toado" :name="`marker-sgd`" :zIndexOffset="1100"
                @click="clickMarkerSoGiaoDuc(sgd.so_id)">
                <LIcon class-name="bg-none border-none">
                    <CircleMarker bg-color="bg-white w-10 h-10" class-icon="fas fa-hotel text-2xl text-red-500">
                    </CircleMarker>
                </LIcon>
                <LTooltip :options="{
                    permanent: false,
                    direction: 'auto',
                    opacity: 0.9,
                    interactive: true,
                    offset: [20, 5],
                    className: '!border-none !p-0 !m-1 !shadow-none'
                }" class="text-yellow-500 drop-shadow-md" v-if="sgd">
                    {{ sgd.tenso }}
                </LTooltip>
            </LMarker>


            <LMarker v-if="markersClick.from" :lat-lng="markersClick.from.latLng">
                <LIcon class-name="bg-none border-none">
                    <CircleMarker bg-color="bg-red-500 w-10 h-10" class-icon="fa fa-map-pin text-2xl">
                    </CircleMarker>
                </LIcon>
            </LMarker>

            <LMarker v-if="markersClick.to" :lat-lng="markersClick.to.latLng">
                <LIcon class-name="bg-none border-none">
                    <CircleMarker bg-color="bg-blue-500 w-10 h-10" class-icon="pi pi-map-marker text-2xl">
                    </CircleMarker>
                </LIcon>
            </LMarker>
        </LMap>
    </div>
</template>

<script setup>
const { $api } = useNuxtApp()
import L from 'leaflet'
import { LocateControl } from "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css"; // LocateControl styles
const config = useRuntimeConfig()
const zoom = ref(11);
const props = defineProps(['data']);
const center = ref([9.812, 106.299]);
const maxBounds = ref([
    [9.017334, 107.121079],
    [10.624767, 105.599280]
]);
const updateZoom = (value) => {
    zoom.value = value;
};
const url = ref('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png');
const attribution = ref('&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors');
const selectedPhongGd = ref([]);
const phongGDSelectAll = ref(false);
const phongGds = ref([]);
const geojsons = ref();

const selectedCaphoc = ref([]);
const caphocSelectAll = ref(false);
const capHocs = ref([]);

const selectedLoaihinh = ref([]);
const loaihinhSelectAll = ref(false);
const loaiHinhs = ref([]);
const itemsStyle = [
    {
        name: 'default',
        label: 'Mặc định',
        icon: 'fa-solid fa-globe',
        layer: {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
    },
    {
        name: 'satellite',
        label: 'Vệ tinh',
        icon: 'fa-solid fa-satellite',
        layer: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        },
    },
    // {
    //     label: 'Địa hình',
    //     icon: 'fa-solid fa-mountain',
    //     layer: {
    //         url: `https://api.mapbox.com/v4/mapbox.terrain-rgb/{z}/{x}/{y}.png?access_token=${config.public.MAPBOX_TOKEN}`,
    //         attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    //     },
    // },
    {
        name: 'light',
        label: 'Sáng',
        icon: 'fa-solid fa-sun',
        layer: {
            url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/">CARTO</a>',
        },
    },
    {
        name: 'dark',
        label: 'Tối',
        icon: 'fa-solid fa-moon',
        layer: {
            url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/">CARTO</a>',
        },
    },
    {
        name: 'outdoors',
        label: 'Ngoài trời',
        icon: 'fa-solid fa-water',
        layer: {
            url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/">CARTO</a>',
        },
    },
];
watch(selectedPhongGd, (newValue, oldValue) => {
    geojsons.value = getGeoJson(newValue);
});

const getStyle = (option) => {
    return option.style;
};
const phongGDSelectAllHook = async (event) => {
    if (event.checked) {
        selectedPhongGd.value = [...phongGds.value].map((e) => e.phong_id);
    } else {
        selectedPhongGd.value = [];
    }
    await nextTick();
};
const getGeoJson = (_data) => {
    const _geoJson = phongGds.value
        .filter((e) => _data.includes(e.phong_id))
        .map((e) => {
            e.dm_huyen.style.fillOpacity = 0;
            return {
                geojson: e.dm_huyen.geojson,
                options: {
                    style: e.dm_huyen.style,
                    id: e.phong_id,
                    center: e.dm_huyen.toado_center,
                    toado: e.toado,
                    title: e.tenphong,
                    diachi: e.diachi,
                    dienthoai: e.dienthoai,

                }
            };
        });
    return _geoJson;
};

const caphocSelectAllHook = async (event) => { };

const loaihinhSelectAllHook = async (event) => { };
const currentLocation = ref()
const currentLocationObj = computed(() => {
    return {
        truong_id: -1,
        ten_truong: 'Vị trí của tôi',
        toado: currentLocation.value ? [currentLocation.value.lat, currentLocation.value.lng] : center.value
    }
})
const sgd = ref()
// onMounted(() => {});
const onMapReady = async (event) => {
    // Add Locate Control to the map
    const locateControl = new LocateControl({
        position: "bottomright", // Position of the locate button
        strings: {
            title: "Show my location", // Tooltip text
        },
        flyTo: true, // Automatically fly to the user's location
        setView: true,
        locateOptions: {
            enableHighAccuracy: true,  // Yêu cầu độ chính xác cao
            maxZoom: 16,               // Đặt zoom tối đa khi định vị
            timeout: 10000,            // Thời gian chờ tối đa (10s)
            watch: true,               // Theo dõi liên tục vị trí           // Không sử dụng dữ liệu đã lưu
        },
        onLocationError: (err) => {
            console.error("Lỗi định vị:", err.message);
            // Bạn có thể hiển thị thông báo tùy chỉnh tại đây, ví dụ:
            showToast('warn', 'Để cải thiện độ chính xác, vui lòng cấp quyền truy cập vị trí', 10000)
        },
    })

    locateControl.addTo(map.value.leafletObject)
    await locateControl.start()
    // Bạn cũng có thể thêm tùy chọn `setView` cho việc tập trung vào vị trí
    map.value.leafletObject.on('locationfound', function (e) {
        currentLocation.value = e.latlng
    });

    // // Bạn cũng có thể thêm tùy chọn `setView` cho việc tập trung vào vị trí
    // map.value.leafletObject.on('locationerror', function (e) {
    //     e.stopPropagation();
    //     showToast('error', 'Không thể lấy vị trí hiện tại của bạn. Vui lòng cấp quyền truy cập vị trí')
    // });
    const data = props.data.data;

    const _style = itemsStyle.find(e => e.name == 'default')
    const _layer = _style.layer
    url.value = _layer.url
    attribution.value = _layer.attribution
    selectedStyle.value = _style

    phongGds.value = [...data.phongGds];
    phongGDSelectAll.value = true;
    selectedPhongGd.value = [...phongGds.value].map((e) => e.phong_id);

    capHocs.value = [...data.capHocs];
    selectedCaphoc.value = [...capHocs.value].map((e) => e.cap_id);

    loaiHinhs.value = [...data.loaiHinhs];
    selectedLoaihinh.value = [...loaiHinhs.value].map((e) => e.loaihinh_id);

    sgd.value = { ...data.soGd[0] }

    layDuLieu();
    await nextTick()
    btnMenu.value.$el.click()

};
const map = ref()
const currentBounds = ref()
const updateMapBound = (bound) => {
    currentBounds.value = bound
}
const dsTruongHoc = ref([]);

const dsTruongHocFilter = computed(() => {
    const bounds = currentBounds.value || map.value.leafletObject.getBounds()
    return dsTruongHoc.value.filter(e => {
        const markerLatLng = L.latLng(e.toado[0], e.toado[1]);
        const isInBounds = bounds.contains(markerLatLng);
        const _dsCapHoc = e.truonghoc_caphoc.find(ee => selectedCaphoc.value.includes(ee.cap_id))
        return selectedPhongGd.value.includes(e.phong_id) && selectedLoaihinh.value.includes(e.loaihinh_id) && isInBounds && _dsCapHoc && zoom.value >= 12
    })
})
const layDuLieu = async () => {
    try {
        const { data, error } = await useFetch('/api/map/truong-hoc/danh-sach', {
            method: 'post',
            body: {
                dsPhongGd: selectedPhongGd.value,
                dsCapHoc: selectedCaphoc.value,
                dsLoaiHinh: selectedLoaihinh.value
            },
            headers: useRequestHeaders(['cookie'])
        });
        if (error.value) {
            showToast('error', 'Có lỗi');
        }
        if (data.value) {
            dsTruongHoc.value = data.value.data;
            if (dsTruongHoc.value.length > 0 && currentLocation.value) {
                dsTruongHoc.value = [...sortValue(dsTruongHoc.value, currentLocation.value)]
            }
        }

    } catch (error) {
        console.log('lỗi danh sách trường', error);
    }
};

const selectedMarkerTruongHoc = ref(null)
const selectedMarkerPhongGiaoDuc = ref(null)
const selectedMarkerSoGiaoDuc = ref(null)
const isLoadingDetail = ref(false)
const isShowDialogMarker = ref(false)
const clickMarkerTruongHoc = async (truongId) => {
    isLoadingDetail.value = false
    op.value.hide();
    isShowDialogMarker.value = true
    try {
        const { data, error: errorData, status } = await useFetch(`/api/map/truong-hoc/${truongId}`, {
            headers: useRequestHeaders(['cookie'])
        });
        isLoadingDetail.value = status.value == 'success' ? true : false
        if (errorData.value) {
            showToast('error', errorData.value.data?.message || 'Có lỗi');
        }
        if (data.value) {
            selectedMarkerTruongHoc.value = data.value.data;

        }
        console.log('lấy xong dữ liệu');

    } catch (error) {
        console.log('lỗi danh sách trường', error);
    }

}

const clickMarkerPhongGiaoDuc = async (phongId) => {
    isLoadingDetail.value = false
    op.value.hide();
    isShowDialogMarker.value = true
    try {
        const { data, error: errorData, status } = await useFetch(`/api/map/phong-giao-duc/${phongId}`, {
            headers: useRequestHeaders(['cookie'])
        });
        isLoadingDetail.value = status.value == 'success' ? true : false
        if (errorData.value) {
            showToast('error', errorData.value.data?.message || 'Có lỗi');
        }
        if (data.value) {
            selectedMarkerPhongGiaoDuc.value = data.value.data;

        }

    } catch (error) {
        showToast('error', errorData.value.data?.message || 'Có lỗi');
    }

}


const clickMarkerSoGiaoDuc = async (soId) => {
    isLoadingDetail.value = false
    op.value.hide();
    isShowDialogMarker.value = true
    try {
        const { data, error: errorData, status } = await useFetch(`/api/map/so-giao-duc/${soId}`, {
            headers: useRequestHeaders(['cookie'])
        });
        isLoadingDetail.value = status.value == 'success' ? true : false
        if (errorData.value) {
            showToast('error', errorData.value.data?.message || 'Có lỗi');
        }
        if (data.value) {
            selectedMarkerSoGiaoDuc.value = data.value.data;

        }

    } catch (error) {
        showToast('error', errorData.value.data?.message || 'Có lỗi');
    }

}


const onHideDialogMarker = () => {
    selectedMarkerTruongHoc.value = null
    selectedMarkerPhongGiaoDuc.value = null
    selectedMarkerSoGiaoDuc.value = null
    isLoadingDetail.value = false
}
const selectedStyle = ref({ name: 'default' })


const changeLayer = (item) => {
    const _layer = item.layer
    selectedStyle.value = item
    url.value = _layer.url
    attribution.value = _layer.attribution
}
const op = ref();
const btnMenu = ref(null)
const isShowMenu = ref(false)
const toggleMenu = (event) => {
    isShowMenu.value = !isShowMenu.value
    op.value.toggle(event);
}
const onHideOp = () => {
    isShowMenu.value = false
}
const opSearch = ref()
const searchValue = ref()
const dsTruongHocSearch = ref([])
const drawerFindLocation = ref(false)
const clickClearSearchValue = (event) => {
    searchValue.value = null
}
const find2Location = computed(() => {
    return [searchValueFrom.value, searchValueTo.value]
})
const hideDrawer = () => {
    searchValueFrom.value = null
    searchValueTo.value = null

    markersClick.value = {
        from: null,
        to: null
    }
}
const toggleSearch = (event) => {
    // opSearch.value.toggle(event)
    drawerFindLocation.value = true
    setTimeout(() => {
        refAutoFrom.value.$el.querySelector('input').focus()

        if (searchValue.value) {
            searchValueFrom.value = { ...searchValue.value }
        }
    }, 100);


}
const searchTruongHoc = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            dsTruongHocSearch.value = [...dsTruongHoc.value];
        } else {
            dsTruongHocSearch.value = dsTruongHoc.value.filter((e) => {
                return removeAccents(e.ten_truong.toLowerCase().trim()).includes(removeAccents(event.query.toLowerCase().trim()));
            });
        }
    }, 300);
}



watch(currentLocation, (newValue, oldValue) => {
    if (newValue) {
        dsTruongHoc.value = [...sortValue(dsTruongHoc.value, newValue)]
    }
});

const sortValue = (ds, toado) => {
    if (ds.length > 0 && toado) {
        const _sortedCoordinates = ds.reduce((acc, coord) => {
            const khoang_cach = haversine(parseFloat(coord.toado[0]), parseFloat(coord.toado[1]), toado.lat, toado.lng); acc.push({ ...coord, khoang_cach }); return acc;
        }, []).sort((a, b) => a.khoang_cach - b.khoang_cach);
        return _sortedCoordinates
    }
    else {
        return ds
    }
}
const searchValueFrom = ref()
const dsTruongHocSearchFrom = ref([])
const refAutoFrom = ref()
const searchTruongHocFrom = (event) => {
    setTimeout(() => {
        const idTo = searchValueTo.value?.truong_id || -99999 // filter bỏ đi select đã chọn
        if (!event.query.trim().length || (searchValueFrom.value && searchValueFrom.value.truong_id == -1)) {
            dsTruongHocSearchFrom.value = [...dsTruongHoc.value].filter(e => e.truong_id != idTo);
        } else {
            dsTruongHocSearchFrom.value = dsTruongHoc.value.filter((e) => {
                return removeAccents(e.ten_truong.toLowerCase().trim()).includes(removeAccents(event.query.toLowerCase().trim())) && (e.truong_id != idTo)
            });
        }

        if (idTo != -1) //loại bỏ đi vị trí của tôi
            dsTruongHocSearchFrom.value.unshift(currentLocationObj.value)
    }, 300);
}
const clickClearSearchValueFrom = () => {
    searchValueFrom.value = null
    setTimeout(() => {
        refAutoFrom.value.$el.querySelector('input').focus()
    }, 300);
}
const searchValueTo = ref()
const dsTruongHocSearchTo = ref([])
const refAutoTo = ref()
const searchTruongHocTo = (event) => {
    setTimeout(() => {
        const idFrom = searchValueFrom.value?.truong_id || -99999  // filter bỏ đi select đã chọn
        if (!event.query.trim().length || (searchValueTo.value && searchValueTo.value.truong_id == -1)) {
            dsTruongHocSearchTo.value = [...dsTruongHoc.value].filter(e => e.truong_id != idFrom);
        } else {
            dsTruongHocSearchTo.value = dsTruongHoc.value.filter((e) => {
                return removeAccents(e.ten_truong.toLowerCase().trim()).includes(removeAccents(event.query.toLowerCase().trim())) && (e.truong_id != idFrom)
            });
        }
        if (idFrom != -1) //loại bỏ đi vị trí của tôi
            dsTruongHocSearchTo.value.unshift(currentLocationObj.value)
    }, 500);
}
const clickClearSearchValueTo = () => {
    searchValueTo.value = null
    setTimeout(() => {
        refAutoTo.value.$el.querySelector('input').focus()
    }, 300);
}


const markerRefs = ref([])
const selectTruongHocSearch = (event) => {
    if (event) {
        const _toado = event.value.toado.map(e => parseFloat(e))
        map.value.leafletObject.setView(_toado, 20)
        if (event.value.truong_id > 0) {
            setTimeout(() => {
                console.log(markerRefs);
                const _marker = markerRefs.value.find(e => e.name == event.value.ma_moet)
                _marker.leafletObject.openTooltip()
                // clickMarkerTruongHoc(event.value.truong_id)

            }, 500);
        }
        else {
            map.value.leafletObject.closeTooltip();
        }
    }
}

const focusedAutocomplete = ref(null)
const setFocusedAutocomplete = (index) => { focusedAutocomplete.value = index; };
const markersClick = ref({
    from: null,
    to: null
})
const addMarker = (event) => {
    if (drawerFindLocation.value) {
        const { lat, lng } = event.latlng;
        const strLatlng = `${lat.toFixed(6)}, ${lng.toFixed(6)}`
        if (!focusedAutocomplete.value) { // trường hợp bình thường marker chưa đủ và đang không focus vào bất kì marker nào
            if (!markersClick.value.from) {
                markersClick.value.from = { latLng: [lat, lng] }
                searchValueFrom.value = { truong_id: -2, ten_truong: strLatlng, toado: [lat, lng] }
            }
            else if (!markersClick.value.to) {
                markersClick.value.to = { latLng: [lat, lng] }
                searchValueTo.value = { truong_id: -3, ten_truong: strLatlng, toado: [lat, lng] }
            }

        }
        else if (focusedAutocomplete.value == 1) { // trường hợp đang focus vào marker điểm đi
            markersClick.value.from = { latLng: [lat, lng] }
            searchValueFrom.value = { truong_id: -2, ten_truong: strLatlng, toado: [lat, lng] }
        }
        else if (focusedAutocomplete.value == 2) { // trường hợp đang focus vào điểm đến
            markersClick.value.to = { latLng: [lat, lng] }
            searchValueTo.value = { truong_id: -3, ten_truong: strLatlng, toado: [lat, lng] }
        }

        focusedAutocomplete.value = null
    }
}

const swapMarkerToFrom = () => {
    if (searchValueFrom.value && searchValueTo.value) {
        const _tempFrom = searchValueFrom.value
        const _tempTo = searchValueTo.value

        searchValueFrom.value = _tempTo
        searchValueTo.value = _tempFrom
    }
}
const clickTimDuong = () => {
    if (!find2Location.value[0].truong_id || !find2Location.value[1].truong_id) {
        showToast('error', 'Vui lòng chọn điểm đi và điểm đến')
        return
    }
    $().$confirm.require({
        group: 'headless',
        header: 'Xác nhận',
        message: `Điểm đi ${find2Location.value[0].ten_truong} -> ${find2Location.value[1].ten_truong}. Xác nhận để mở trang google map.`,
        icon: 'pi pi-fw pi-check',
        accept: async () => {

            await navigateTo(`https://www.google.com/maps/dir/?api=1&origin=${find2Location.value[0].toado.join(',')}&destination=${find2Location.value[1].toado.join(',')}&travelmode=motorcycle`, {
                open: {
                    target: '_blank',
                }
            })
        },
        reject: () => {

        }
    })
}
// watchEffect(() => {
//     phongGds.value = [...props.data.data];
//     phongGDSelectAll.value = true;
//     selectedPhongGd.value = [...phongGds.value].map((e) => e.phong_id);
//     geojsons.value = getGeoJson();
// });

//#region utils
function haversine(lat1, lon1, lat2, lon2) {
    const R = 6371; // Bán kính Trái Đất tính bằng km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Khoảng cách tính bằng km
    return distance;
}

//#endregion
</script>

<style>
#map {
    width: 100%;
    height: 500px;
}

.leaflet-popup-content {
    width: min(90rem, 100vw) !important;
    max-height: min(500px, 50vh);
    max-width: 100vh !important;
    margin: 0 !important
}
</style>